<dx-gantt
  [taskListWidth]="taskListWidth"
  [scaleType]="scaleType"
  [height]="height"
  [columns]="columns"
  [selectedRowKey]="selectedRowKey">

  <dxo-tasks [dataSource]="tasks"></dxo-tasks>

  <dxo-validation [autoUpdateParentTasks]="false"></dxo-validation>
  <dxo-editing [enabled]="false"></dxo-editing>
</dx-gantt>
